import type {ReactNode} from 'react'
import Instagram from '@local/assets/svgs/socials/instagram.svg'
import Twitter from '@local/assets/svgs/socials/twitter.svg'
import Linkedin from '@local/assets/svgs/socials/linkedin.svg'

export interface SocialsLogoProps {
	children: ReactNode
	className: string
}

export const SocialsLogo = ({icon}) => {
	switch (icon) {
		case 'instagram':
			return (<Instagram />)
		case 'twitter':
			return (<Twitter />)
		case 'linkedin':
			return (<Linkedin />)
		default:
			return (<></>)
	}
}
